import { useTranslation } from "react-i18next";
import { NeuInput, NeuSelect } from "../../components/neu/Neu";

const KINDS = ["cash", "days_7", "days_15", "days_30", "days_45",
               "days_60", "days_90", "advance", "cod", "installments"];
const DAYS = { cash: 0, days_7: 7, days_15: 15, days_30: 30, days_45: 45,
               days_60: 60, days_90: 90, advance: 0, cod: 0 };

// تاريخ التسليم المتوقع + شروط الدفع (تاريخ الإنشاء يُثبَّت في الخادم).
export const BuilderTerms = ({ head, onChange, needsSupplier }) => {
  const { t } = useTranslation();
  const setNeeded = (e) => onChange({ ...head, needed_by: e.target.value });
  const setKind = (e) => {
    const kind = e.target.value;
    onChange({ ...head, payment_terms_kind: kind,
                payment_terms_days: DAYS[kind] ?? null });
  };
  return (
    <>
      <label className="grid gap-1.5">
        <span className="text-[11px] font-bold text-muted-foreground">
          {t("purchases.cols.neededBy")}
        </span>
        <NeuInput data-testid="purchase-needed-by" type="date"
                  min={head.date}
                  value={head.needed_by || head.date} onChange={setNeeded} />
      </label>
      {needsSupplier ? (
        <label className="grid gap-1.5">
          <span className="text-[11px] font-bold text-muted-foreground">
            {t("purchases.paymentTermsKind")}
          </span>
          <NeuSelect data-testid="purchase-payment-kind"
                     value={head.payment_terms_kind || "cash"} onChange={setKind}>
            {KINDS.map((k) => (
              <option key={k} value={k}>{t(`purchases.paymentKinds.${k}`)}</option>
            ))}
          </NeuSelect>
        </label>
      ) : null}
    </>
  );
};
